import { GameStateTypes } from './config/GameStateTypes';
const { LIVE, PREVIEW, FINAL } = GameStateTypes;

const BASE = 'base';
const EXTENDED = 'extended';
const getGameStateBaseLabel = (options) => {
    const {
        gameStatus,
        currentInning,
        isPreGameDelay,
        isTBD,
        isWarmup,
        isSuspended,
        isInGameDelay,
        isInstantReplay,
        isManagerChallenge,
        isUmpireReview,
        isPostponed,
        isCancelled,
        inningState = '',
        isSuspendedResumptionOnDate,
        gameTime,
        scheduledInnings,
        isMobile,
        statusCode,
        inningOrdinal,
        shouldUseOrdinal
    } = options;

    const content = {
        base: {
            text: '',
            dictkey: '',
            spacer: ' ',
            additionalText: []
        },
        extended: {
            text: '',
            dictkey: '',
            additionalText: []
        }
    };

    switch (gameStatus) {
        case PREVIEW:
            if (!isPreGameDelay) {
                content[BASE].text = (isTBD) ? 'TBD' : gameTime;
            } else {
                content[BASE].text = 'Delayed Start';
                content[BASE].dictkey = 'game_status_delayed_start';
            }
            return content;
        case LIVE:

            if (inningState) {
                const inningText = inningState.substring(0, 3);
                content[BASE].text = inningText + ' ' + currentInning;
                content[BASE].additionalText = [];
                content[BASE].replacement = { inning: currentInning, inningOrdinal };

                if (inningState === 'Top') {
                    content[BASE].dictkey = shouldUseOrdinal ? 'inning_state_top' : 'inning_state_top_abbrev';
                } else if (inningState === 'Bottom') {
                    content[BASE].dictkey = shouldUseOrdinal ? 'inning_state_bottom' : 'inning_state_bottom_abbrev';
                } else if (inningState === 'Middle') {
                    content[BASE].dictkey = 'inning_state_mid_abbrev';
                } else if (inningState === 'End') {
                    content[BASE].dictkey = 'inning_state_end_abbrev';
                }
            }

            if (isWarmup) {
                content[BASE].text = 'Warmup';
                content[BASE].dictkey = 'game_status_warmup_short';
                content[BASE].additionalText = [];
            } else if (isSuspended && !isSuspendedResumptionOnDate) {
                content[EXTENDED].text = 'Suspended';
                content[EXTENDED].dictkey = 'game_status_suspended';
            } else if (isSuspendedResumptionOnDate) {
                content[EXTENDED].text = gameTime;
                content[EXTENDED].dictkey = '';
            } else if (isInGameDelay) {
                content[EXTENDED].text = 'Delay';
                content[EXTENDED].dictkey = 'game_status_delayed';
            } else if (isInstantReplay) {
                content[EXTENDED].text = 'Replay';
                content[EXTENDED].dictkey = 'game_status_replay';
            } else if (isManagerChallenge) {
                if (statusCode === 'MJ') {
                    content[EXTENDED].text = 'Player Challenge';
                    content[EXTENDED].dictkey = 'game_status_player_challenge';
                } else {
                    content[EXTENDED].text = 'Manager Challenge';
                    content[EXTENDED].dictkey = 'game_status_manager_challenge';
                }
            } else if (isUmpireReview) {
                content[EXTENDED].text = 'Umpire Review';
                content[EXTENDED].dictkey = 'game_status_umpire_review';
            }

            return content;

        case FINAL:
            if (isCancelled) {
                content[BASE].text = 'Cancelled';
                content[BASE].dictkey = 'game_status_cancelled';
            } else if (isPostponed) {
                content[BASE].text = 'Postponed';
                content[BASE].dictkey = 'game_status_postponed';
            } else {
                if (currentInning !== scheduledInnings) {
                    content[BASE].text = isMobile ? 'F' : FINAL;
                    content[BASE].dictkey = isMobile ? null : 'game_status_final';
                    content[BASE].additionalText = [`/${currentInning}`];
                    content[BASE].spacer = '';
                } else {
                    content[BASE].text = FINAL;
                    content[BASE].dictkey = 'game_status_final';
                }
            }
            return content;
        default:
            return content;
    }
};

export default getGameStateBaseLabel;
